import {useEffect} from 'react';

/**
 * Calls `handler` when a mousedown occurs outside the referenced element.
 * No-op while `active` is false.
 */
export default function useClickOutside(ref, handler, active) {
    useEffect(() => {
        if (!active) {
            return;
        }
        const onMouseDown = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                handler();
            }
        };
        document.addEventListener('mousedown', onMouseDown);
        return () => document.removeEventListener('mousedown', onMouseDown);
    }, [ref, handler, active]);
}


